export default "9e070e8b2c78fa8c.svg"